module.exports = __webpack_public_path__ + "img/logo.6383c0f6.svg";